import AbsComponent from "../AbsComponent";

class SearchBox extends AbsComponent{
    constructor(_store={}, _router={}, _el=''){
        super('class SearchBox', _store, _router, _el);

        let _apiUrl = 'https://searchsuggest.plaync.com/suggest/lineage2/v1.0/dic';
        if(/loc|opd|sb-|rc-|rc\./.test(location.host.slice(0,3))){
            _apiUrl = 'https://rc-searchsuggest.plaync.com/suggest/lineage2/v1.0/dic';
        }

        this.autoSuggest = new AutoSuggest();
        this.autoSuggest.init({
            selector : '#autoSuggest',
            service: 'lineage2',
            alias: 'dic',
            size: 10,
            useDelbtn: true,
            apiUrl: _apiUrl,
            addParam: {
                server_id: (this.store.getState().config.tab=='lineage2'? 'Aden': 'Work'),
                service_code: (this.store.getState().config.db=='item'? 'Item': 'Skill')
            },
            submitCallback: (_q)=>{
                this.router.goMultiParam( {'query': _q} );
            }
        });

        let watchQuery = this.watch(this.store.getState, 'query', this.isEqual);
        this.store.subscribe( watchQuery( (newVal, oldVal, path) => this.render(newVal, oldVal, path)));

        this.render(this.store.getState().query);

        $("#autoSuggest [data-name='suggest_submit']").on('click', (e)=>{
            if ($("#autoSuggest [data-name='suggest_input']").val().trim() == '') {
                this.router.goMultiParamSetListPage( {'query': ''} );
            }
        });


        $("#autoSuggest [data-name='suggest_delete']").on('click', (e)=>{
            if ($("#autoSuggest [data-name='suggest_input']").val().trim() == '') {
                this.router.goMultiParamSetListPage( {'query': ''} );
            }
        });
    }

    render(_newVal, _oldVal, _path){
        this.autoSuggest.value(_newVal);
    }

} // end of class
export default SearchBox;